/**
 * @generated SignedSource<<23e3b206e195d5622e1b6f70c912a82b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UploadSeriesAclQuery$variables = {
  seriesId: string;
};
export type UploadSeriesAclQuery$data = {
  readonly series: {
    readonly acl: ReadonlyArray<{
      readonly actions: ReadonlyArray<string>;
      readonly info: {
        readonly assignableActions: ReadonlyArray<string> | null | undefined;
        readonly implies: ReadonlyArray<string> | null | undefined;
        readonly label: { default: string } & Record<string, string | undefined>;
        readonly safeActions: ReadonlyArray<string>;
      } | null | undefined;
      readonly role: string;
    }>;
    readonly id: string;
  } | null | undefined;
};
export type UploadSeriesAclQuery = {
  response: UploadSeriesAclQuery$data;
  variables: UploadSeriesAclQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "seriesId"
  }
],
v1 = [
  {
    "alias": "series",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "seriesId"
      }
    ],
    "concreteType": "Series",
    "kind": "LinkedField",
    "name": "seriesByOpencastId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AclItemWithInfo",
        "kind": "LinkedField",
        "name": "acl",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoleInfo",
            "kind": "LinkedField",
            "name": "info",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "implies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "safeActions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assignableActions",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadSeriesAclQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadSeriesAclQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc35f85fafb40703681d481f437abc2e",
    "id": null,
    "metadata": {},
    "name": "UploadSeriesAclQuery",
    "operationKind": "query",
    "text": "query UploadSeriesAclQuery(\n  $seriesId: String!\n) {\n  series: seriesByOpencastId(id: $seriesId) {\n    id\n    acl {\n      role\n      actions\n      info {\n        label\n        implies\n        safeActions\n        assignableActions\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e9c5a4f1051071d3d1d31933837f05e";

export default node;
